import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found in index.html');

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

// Глобальные ошибки вне React-дерева — хотя бы в консоль (видно при отладке
// с подключённым устройством; задел под будущий /api/client-log или Sentry).
window.addEventListener('error', (e) => console.error('window.onerror:', e.message, e.error));
window.addEventListener('unhandledrejection', (e) => console.error('unhandledrejection:', e.reason));

// При активации новой версии SW — молча перезагружаем страницу,
// чтобы пользователь не сидел на старом bundle.
registerSW({
  immediate: true,
  onRegisteredSW(_swUrl, registration) {
    if (!registration) return;
    // Проверяем обновления раз в минуту пока открыто (+ при возврате на вкладку)
    setInterval(() => {
      registration.update().catch(() => {});
    }, 60_000);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) registration.update().catch(() => {});
    });
  },
  onNeedRefresh() {
    window.location.reload();
  },
});

// Подстраховка: когда новый SW переехал в active — перезагружаем
if ('serviceWorker' in navigator) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}
